import { Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import {
  formatBackendDateToMonthYear,
  formatBackendDateToQuarterMonthYear,
} from 'modules/core/lib/dates'

export const Period = ({
  accountingDate,
  aeatClosingPeriodFrequency,
}: {
  accountingDate: string | undefined
  aeatClosingPeriodFrequency: string | null | undefined
}) => {
  const formatedAccountingDate = () =>
    aeatClosingPeriodFrequency === 'quarterly'
      ? formatBackendDateToQuarterMonthYear(moment(accountingDate))
      : formatBackendDateToMonthYear(moment(accountingDate))

  return <Text.Normal size="200">{formatedAccountingDate()}</Text.Normal>
}
